import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import { DialogContentText } from '@mui/material';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'components/Dialog';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const ScreenshareLimitReachedModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);

  const hideModal = () => dispatch(closeModal('screenshareLimitReached'));

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="screenshare-limit-reached-dialog"
      aria-describedby="screenshare-limit-reached-description"
      onClose={hideModal}
      open
    >
      <DialogTitle id="screenshare-limit-reached-dialog" onClose={hideModal}>
        {t('screenshare_limit_reached.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="screenshare-limit-reached-description">
          {t('screenshare_limit_reached.description', { count: modalData.limit })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={hideModal} color="grayscale">
          {t('screenshare_limit_reached.btn_close_label')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScreenshareLimitReachedModal;
